import React, { Component } from 'react'
import { db } from "../../firebase";
import firebase from "firebase"
import {Image} from 'react'

class Reports extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      uploads: []
    };
    this.real = this.real.bind(this);
  }
  real(item){
    if(item == "Yes"){
        return (<h6 style ={{color:"red"}}>Real</h6> );
    }
    else if(item == "No"){
        return (<h6 style ={{color:"red"}}>Fake</h6>);
    }
}
  componentDidMount() {
    db.collection("uploads")
      .get()
      .then(querySnapshot => {
        const data = querySnapshot.docs.map(doc => doc.data());
        this.setState({ uploads: data });
      });
  }
  render() {
    const { uploads } = this.state;
    return (
      <div className="row">
        {uploads.map(upload => (
          <div key={upload.uid}>
            <div className="card h-100">
              <div className="card row">
                <div className="card-body col">
                    <img src={upload.imageUrl} style={{width:"400px"}}/>
                </div>
                <div className="card-body col-6">
                  <h5>{upload.title}</h5>
                  <h6>Location: {upload.location}</h6>
                  <h6>{upload.description}</h6>
                  {this.real(upload.confirm)}      
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
export default Reports